import React, { useState } from 'react';
import { makeStyles, TextField, Grid } from '@material-ui/core';
import { showNotification } from '../../App';
// import draftToHtml from 'draftjs-to-html';
import { client } from '../..';
// import { NewEnquiryControlPanel } from '../controls/NewEnquiryControlPanel';
import { FetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { EmailTemplateList, EmailTemplateTypeEnum } from '../EmailTemplateRespository';
import NewEnquiryResponseTable from '../tables/NewEnquiryResponseTable';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { RvLoader } from '../../components/Loader';
import { EditorWrapper } from '../../components/Editor';

const useStyles = makeStyles({
    root: {
        flex: 1,
        display: 'flex',
        flexFlow: 'column',
    },
    content: {
        display: 'flex',
        flexFlow: 'column',
        flex: 1,
        // padding: '0 30px 15px 30px',
        position: 'relative',
        minHeight: 500,
        '& > .tox': {
            flex: 1,
        }
    },
    previewContainer: {
        margin: '0 -30px',
    },
    wrapperClassName: {
        display: 'flex',
        flexFlow: 'column',
        flex: 1,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    toolbarClassName: {
        backgroundColor: '#fafbff',
    },
    editorClassName: {
        border: '1px solid #F1F1F1',
        padding: '0 10px',
    },
    textField: {
        width: '100%',
    },
    subjectWrapper: {
        paddingBottom: '10px',
    },
    tableWrapper: {
        paddingBottom: 15,
    },
    loadingWrapper: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    }
});

export enum EmailStyle {
    HTML = 0,
    ADAPTIVE_CARD = 1,
    VISION_SIX = 2
} 

interface TemplateTabProps {
    emailType: EmailTemplateTypeEnum;
    onDataChanged?: (isDataChanged: boolean) => void;
}

interface EmailTemplateQueryProps {
    roleId: string | null;
    selectedUserId: string | null;
}

interface TemplateTabState extends EmailTemplateQueryProps {
    editorState: string;
    isLoading: boolean;
    isEditorHidden: boolean;
    subject: string;
    onErrorSubject: boolean;
    // tslint:disable-next-line: no-any
    matchedPropertyInput: any;
    isPreview: boolean;
    previewTemplate: string;
    integrationTemplateId: string | null;
    emailStyle: number | null;
    emailType: number | null;
    areaOfLawGuid: string | null;
    isRowSelected: boolean;
    isCreate: boolean;
    isTemplateLoading: boolean;
}

export default function NewEnquiryResponseTemplateTab(props: TemplateTabProps) {

    const classes = useStyles();

    const [state, setState] = useState<TemplateTabState>({
        editorState: '',
        roleId: null,
        selectedUserId: null,
        isLoading: true,
        isEditorHidden: false,
        subject: '',
        onErrorSubject: false,
        matchedPropertyInput: [],
        isPreview: false,
        previewTemplate: '',
        integrationTemplateId: null,
        emailStyle: null,
        emailType: null,
        areaOfLawGuid: null,
        isRowSelected: false,
        isCreate: false,
        isTemplateLoading: true
    });

    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                subject: event.target.value
            };
        });

        if (props.onDataChanged) {
            props.onDataChanged(true);
        }
    };

    const onNewEnquiryResponseTableDataChanged = (isChanged: boolean) => {
        if (props.onDataChanged) {
            props.onDataChanged(isChanged);
        }
    };

    // tslint:disable-next-line: no-any
    const onRowClick = (event?: React.MouseEvent, rowData?: EmailTemplateList | any, toggleDetailPanel?: (panelIndex?: number) => void) => {
        // tslint:disable-next-line: no-console
        // console.log('onRowClick', rowData);

        setState((prevState) => {
            return {
                ...prevState,
                isRowSelected: true,
                isCreate: false,
                isTemplateLoading: true
            };
        });

        if (rowData) {
            fetchEmailTemplate(
                rowData.emailStyle, 
                rowData.integrationTemplateId,
                // tslint:disable-next-line: max-line-length
                rowData.areaOfLaw,
                rowData.emailTemplateGuid
            );
        }        
    };

    const getFirstData = (rowData: EmailTemplateList) => {
        fetchEmailTemplate(
            rowData.emailStyle, 
            rowData.integrationTemplateId,
            // tslint:disable-next-line: max-line-length
            rowData.matchedPropertys.matchedProperty.length > 0 
                ? { label: rowData.matchedPropertys.matchedProperty[0].keyDescription, value: rowData.matchedPropertys.matchedProperty[0].key }
                : null,
            rowData.emailTemplateGuid
        );
    };

    // tslint:disable-next-line: no-any
    const onAddelection = (areaofLaw: IAutoCompleteItem | null, externalTemplate: IAutoCompleteItem | null | any) => {
        // tslint:disable-next-line: no-console
        
        setState((prevState) => {
            return {
                ...prevState,
                isPreview: externalTemplate !== null ? true : false
            };
        });
        
        if (externalTemplate) {
            fetchEmailTemplate(
                externalTemplate.emailStyle, 
                externalTemplate.externalTemplateId, 
                areaofLaw ? areaofLaw : null,
                null
            );
        }
    };

    const fetchEmailTemplate = (emailStyle: number | null, integrationTemplateId: string | null, areaOfLaw: IAutoCompleteItem | null,
                                emailTemplateGuid: string | null) => {
        
        let emailTemplateQueryParams: EmailTemplateQueryParams = {
            isInternalRole: null,
            roleId: null,
            selectedUserId: null,
            emailType: EmailTemplateTypeEnum[props.emailType],
            emailStyle: emailStyle !== null ? EmailStyle[emailStyle] : null,
            integrationTemplateId: integrationTemplateId ? integrationTemplateId : null,
            areaOfLaw: areaOfLaw ? areaOfLaw.label : null,
            emailTemplateGuid: emailTemplateGuid
        };

        retrieveEmailTemplateData(
            emailTemplateQueryParams,
            true,
            // tslint:disable-next-line: no-any
            (data: any) => onDataRetrieved(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
              showNotification(null, reason, 'error');
        });
    };

    const onDataRetrieved = (data: EmailTemplateData) => {
        
        if (data.templates !== null && data.templates.emailTemplate !== null && data.templates.emailTemplate.template !== null) {
            let editorState = '';

            const emailTemplate = data.templates.emailTemplate;

            if (emailTemplate.emailStyle === 0  || emailTemplate.emailStyle === 1) {
                editorState = emailTemplate.template;
            }

            let areaOfLawGuid: string | null = null;
            const matchedPropertyInput = {
                entity: 'areaOfLaw',
                properties: emailTemplate.matchedPropertys.matchedProperty
            };
            
            setState((prevState: TemplateTabState) => {
                return {
                    ...prevState,
                    editorState: editorState,
                    isPreview: emailTemplate.emailStyle === EmailStyle.HTML || emailTemplate.emailStyle === EmailStyle.ADAPTIVE_CARD ? false : true,
                    previewTemplate: emailTemplate.template,
                    subject: emailTemplate.subject && emailTemplate.subject.length > 0 ? emailTemplate.subject : '',
                    isLoading: false,
                    emailStyle: emailTemplate.emailStyle,
                    integrationTemplateId: emailTemplate.integrationTemplateId,
                    emailType: props.emailType,
                    matchedPropertyInput: matchedPropertyInput,
                    areaOfLawGuid: areaOfLawGuid,
                    isTemplateLoading: false
                };
            });
        } else {
            setState((prevState: TemplateTabState) => {
                return {
                    ...prevState,
                    isTemplateLoading: false
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    const onAddTemplate = (areaOfLaw: IAutoCompleteItem | null, externalTemplate: IAutoCompleteItem | null | any) => {
        // tslint:disable-next-line: no-console

        const matchedPropertyInput = {
            entity: 'areaOfLaw',
            properties: [{
                key: areaOfLaw?.value
            }]
        };

        setState((prevState) => {
            return {
                ...prevState,
                subject: externalTemplate ? `Thank you for your Enquiry - ${externalTemplate.label}` : '',
                integrationTemplateId: externalTemplate ? externalTemplate.value : null,
                emailStyle: externalTemplate ? externalTemplate.emailStyle : 0,
                matchedPropertyInput: matchedPropertyInput,
                isCreate: true
            };
        });
    };

    const onEditorChange = (content: string) => {
        setState((prevState) => {

            if (props.onDataChanged) {
                props.onDataChanged(true);
            }

            return {
                ...prevState,
                editorState: content
            };
        });
    };

    const getRenderTemplate = () => {
        
        if (state.isTemplateLoading && (state.editorState.length > 0 || state.previewTemplate.length > 0)) {
            return (
                <div className={classes.loadingWrapper}>
                    <RvLoader />
                </div>
            );
        }

        if (state.editorState.length > 0 && !state.isEditorHidden && !state.isPreview) {
            return (
                <EditorWrapper 
                    value={state.editorState}
                    onEditorChange={onEditorChange}
                    disabled={true}
                    toolbar={false}
                    menubar={false}
                    emailType={props.emailType}
                />
            );
        }

        if (state.previewTemplate.length > 0 && !state.isEditorHidden && state.isPreview) {
            return (
                <div
                    className={classes.previewContainer}
                    dangerouslySetInnerHTML={{
                        __html: state.previewTemplate
                    }}
                />
            );
        }

        return undefined;
    };

    return (
        <div className={classes.root}>
            {/* <NewEnquiryControlPanel 
                onClickSave={updateTemplate}
                onClickReset={deleteTemplate}
                isLoading={state.isLoading}
                isCreate={state.isCreate}
            /> */}
            {!state.isEditorHidden && (
                <div className={classes.subjectWrapper}>
                    <Grid item={true} xs={12} md={8} lg={8}>
                        <NewEnquiryResponseTable 
                            className={classes.tableWrapper}
                            onDataChanged={onNewEnquiryResponseTableDataChanged}
                            onRowClick={onRowClick}
                            emailType={props.emailType}
                            getFirstData={getFirstData}
                            onSelection={onAddelection}
                            onAddTemplate={onAddTemplate}
                        />
                    </Grid>
                    <Grid item={true} xs={12} md={5} lg={5}>
                        <TextField 
                            label="Email Subject" 
                            value={state.subject} 
                            onChange={handleTextChange} 
                            className={classes.textField} 
                            error={state.onErrorSubject}
                            helperText={state.onErrorSubject ? 'Subject is required' : ''}
                            InputProps={{
                                readOnly: state.isPreview,
                            }}
                            InputLabelProps={{
                                shrink: state.subject.length > 0
                            }}
                            disabled={state.isLoading}
                        />
                    </Grid>
                </div>
            )}
            <div className={classes.content}>
                {getRenderTemplate()}
            </div>
        </div>
    );
}

export interface EmailTemplateQueryParams {
    isInternalRole: boolean | null;
    roleId: string | null;
    selectedUserId: string | null; 
    emailType: string | null;
    emailStyle: string | null;
    integrationTemplateId: string | null;  
    areaOfLaw: string | null;
    emailTemplateGuid: string | null;
}

export interface EmailTemplateData {
    loading?: boolean;
    networkStatus?: number;
    templates: Templates;
}

export interface Templates {
    emailTemplate: EmailTemplate;
}

export interface EmailTemplate {
    emailTemplateGuid: string;
    emailType:         number;
    isInternalRole:    null;
    roleGuid:          null;
    subject:           string;
    template:          string;
    emailStyle:        number;
    userGuid:          null;
    ccAssistant:       boolean;
    matchedPropertys:  MatchedPropertys;
    integrationTemplateId: string;
}
export interface MatchedPropertys {
    entity:          string;
    matchedProperty: MatchedProperty[];
}
export interface MatchedProperty {
    key:                  string;
    keyDescription:       string;
    recipient:            string;
    recipientDescription: string;
    scope:                string;
    scopeDescription:     string;
}

export function retrieveEmailTemplateData(
    query: EmailTemplateQueryParams, 
    refreshData: boolean,
    onSuccess: (data: EmailTemplateData) => void,
    // tslint:disable-next-line:no-any
    onError: (reason: any) => void)
     : void {
        var fetchPolicy: FetchPolicy = refreshData === true ? 'network-only' : 'cache-first';
        client.query({
            query: EmailTemplateQuery,
            variables: {
                isInternalRole: query.isInternalRole,
                roleId: query.roleId,
                selectedUserId: query.selectedUserId,
                emailType: query.emailType,
                emailStyle: query.emailStyle,
                integrationTemplateId: query.integrationTemplateId,
                areaOfLaw: query.areaOfLaw,
                emailTemplateGuid: query.emailTemplateGuid
            },
            fetchPolicy: fetchPolicy
    })
    // tslint:disable-next-line:no-any
    .then((results: { data: any; }) => {
        onSuccess(results.data);
    })
    // tslint:disable-next-line:no-any
    .catch((reason: any ) => { 
        onError(reason); 
    });
}

const EmailTemplateQuery = gql`
    query EmailTemplate(
        $isInternalRole: Boolean, 
        $roleId: String, 
        $selectedUserId: String, 
        $emailType: EmailType,
        $emailStyle: EmailStyle,
        $integrationTemplateId: String,
        $areaOfLaw: String,
        $emailTemplateGuid: String
    ) {
        templates {
        emailTemplate(
            isInternalRole: $isInternalRole, 
            roleId: $roleId, 
            selectedUserId: $selectedUserId, 
            emailType: $emailType,
            emailStyle: $emailStyle,
            integrationTemplateId: $integrationTemplateId,
            areaOfLaw: $areaOfLaw,
            emailTemplateGuid: $emailTemplateGuid
        )   {
                emailTemplateGuid
                emailType
                isInternalRole
                roleGuid
                subject
                template
                emailStyle
                userGuid
                ccAssistant
                integrationTemplateId
                matchedPropertys {
                    entity
                    matchedProperty {
                        key
                        keyDescription
                        recipient
                        recipientDescription
                        scope
                        scopeDescription
                    }
                }
            }
        }
    }
`;